import SkeletonPageLoading from './skeleton-page-loading';

export default SkeletonPageLoading;
